// Better-auth client — the SAME helper tkt-frontend uses (its lib/auth-client.ts). The back office
// talks to better-auth's admin / organization / email-OTP endpoints THROUGH this client
// (authClient.admin.createUser, authClient.organization.*, …) instead of hand-rolled fetches, so
// request shaping, cookie handling, and the { data, error } contract match the platform exactly.
// baseURL comes from lib/backendUrl — the ONE resolver backOfficeApi also uses. This file
// used to carry its own copy gated on a hardcoded BACKEND_DOMAINS allowlist, which sent every
// better-auth call to backend.tkt.ug on any domain outside that list while the rest of the
// console talked to backend.<that-domain> — a cookie-less cross-domain POST that better-auth
// answers with 401. See backendUrl.js for the full account.
import { createAuthClient } from 'better-auth/react';
import { adminClient, emailOTPClient, organizationClient } from 'better-auth/client/plugins';
import { passkeyClient } from '@better-auth/passkey/client';
import { getBackendUrl } from './backendUrl';

// The client is PINNED to the version the backend runs (1.4.21), not floated ahead of it.
// It was on ^1.6 against a 1.4 server — a skew that had already been shipped for the admin,
// organization and email-OTP calls below, and the temptation when adding passkeys was to
// hand-roll fetches around it rather than face it. Two versions of one protocol talking to
// each other is the defect; wrapping it is not a fix. tkt-backend and sellers-dashboard are
// both on 1.4.21, so this is the platform speaking one version of better-auth.
export const authClient = createAuthClient({
  baseURL: getBackendUrl(),
  // The session cookie must ride every auth call: the console and the backend are
  // same-site but cross-origin in dev, and cross-subdomain in production.
  fetchOptions: { credentials: 'include' },
  plugins: [passkeyClient(), emailOTPClient(), adminClient(), organizationClient()],
});
